export default __webpack_public_path__ + "static/media/girl1.09e7742a.png";